import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.nav ``;
const ItemList = styled.ul `
  display: flex;
  align-items: center;
`;
const Item = styled.li `
  display: flex;
  align-items: center;
`;
const Link = styled.a `
  --itemHeight: ${fluid(14, 18, Device.TabletLarge)};
  --padding: ${fluid(12, 32, Device.TabletLarge)};

  position: relative;
  display: inline-block;
  background: none;
  border: 0;
  box-sizing: content-box;
  color: var(--fgColor);
  ${fonts.helvetica.bold};
  font-size: var(--itemHeight);
  height: var(--itemHeight);
  letter-spacing: -0.01em;
  line-height: 1em;
  padding: 16px var(--padding) calc((var(--headerHeight) - var(--itemHeight)) / 2);
  text-decoration: none;
  text-underline-position: under;
  transform: translateX(calc(var(--padding)));

  > svg {
    display: block;
    height: 20px;
    width: 20px;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 50%;
    background: ${brand.blue.base};
    height: 4px;
    transform: translateX(-50%) scaleX(0);
    transform-origin: center;
    transition: transform 0.15s ${cubicEaseOut};
    width: calc(100% - var(--padding) - var(--padding));
  }

  &:focus {
    outline: none;
  }

  ${Item}[data-d-active='true'] &,
  &:focus,
  &:hover {
    &::after {
      transform: translateX(-50%) scaleX(1);
    }
  }
`;
const DesktopNavigationStyles = {
    Container,
    Item,
    ItemList,
    Link,
};
export default DesktopNavigationStyles;
